import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import config from '../../config/constant'
import './headerDetails.css'

export default function PaymentHeaderDetails({ option = {} }) {
  return (
    <div className='approval-card-header '>
      <span>
        <span className='span1'>{`Service No : ${option?.serviceNumber}`}</span>
        <span className='mt-2 span2'>{option?.serviceType}</span>
      </span>
      <span>
        <span className='mb-2 span3'>
          <span className='d-flex span3'>
            {option?.srcCurrency} &nbsp;
            <NumberFormat
              value={option?.amount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              className='span3'
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </span>
        </span>
        <span></span>
        <span className='mt-2 span2 text-right'>
          {option?.initDate !== null ? option?.initDate : '-'}
        </span>
      </span>
    </div>
  )
}
